import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import DesignSystemModal from "../../components/DesignSystem/DesignSysyemModal";
import PageLoader from "../../components/Shared/PageLoader";
import { useKudosDetails } from "../../hooks/useKudosDetails";
import { calcCanGoBack, calcCanGoNext } from "../../utils/navigationCalc";
import KudosDetailsCard from "../KudosDetailsCard/KudosDetailsCard";
import { css } from "@emotion/css";

type Props = {
  show: boolean;
  onCloseModal: (event: React.MouseEvent<HTMLDivElement>) => void;
  selectedKudos: string;
  onChangeKudos: (token: string) => any;
  onCloseModalWithBtn: () => void;
  kudos: { tokenId: string; headline: string; imageUrl: string }[];
};

const KudosDetailsModal = ({
  show,
  onCloseModal,
  onCloseModalWithBtn,
  onChangeKudos,
  kudos,
  selectedKudos,
}: Props) => {
  const [currentKudos, setCurrentKudos] = useState<string>(selectedKudos);
  const router = useRouter();
  const params = router.query;

  const {
    fetchKudosDetails,
    kudosDetails: kudosData,
    loading,
    error,
    contributors,
    contributorsResponse,
    fetchContributors,
    ownersResponse,
    owners,
    fetchOwners,
    endorsers,
  } = useKudosDetails(currentKudos);

  const canGoNext = () => {
    // find index of current kudos and move next
    return calcCanGoNext(currentKudos, kudos);
  };

  const canGoBack = () => {
    // find index of current kudos and move next
    return calcCanGoBack(currentKudos, kudos);
  };

  const [navButtonState, setNavButtonState] = useState({
    left: calcCanGoBack(currentKudos, kudos),
    goPrev: () => onClickPrev(),
    right: calcCanGoNext(currentKudos, kudos),
    goNext: () => onClickNext(),
  });

  useEffect(() => {
    const fetch = async () => {
      onChangeKudos(currentKudos);
      if (currentKudos) {
        setNavButtonState({
          left: calcCanGoBack(currentKudos, kudos),
          goPrev: () => onClickPrev(),
          right: calcCanGoNext(currentKudos, kudos),
          goNext: () => onClickNext(),
        });
        try {
          await fetchKudosDetails(currentKudos);
        } catch (error: any) {
          toast.error(error.message || error);
          router.push(`/profile/${params?.username}`);
        }
      }
    };
    fetch();
  }, [currentKudos]);

  const onClickNext = () => {
    const calc = canGoNext();

    if (calc.canGoNext) {
      const id = kudos[calc.nextIdx].tokenId;
      setCurrentKudos(`${id}`);
    }
  };

  const onClickPrev = () => {
    const calc = canGoBack();

    if (calc.canGoBack) {
      const id = kudos[calc.prevIdx].tokenId;
      setCurrentKudos(`${id}`);
    }
  };

  return (
    <div>
      <DesignSystemModal
        show={show}
        onCloseModal={onCloseModal}
        navButtonState={navButtonState}
        onCloseModalWithBtn={onCloseModalWithBtn}
      >
        <KudosDetailsCard
          details={kudosData}
          contributors={contributors}
          contributorsResponse={contributorsResponse}
          onShowMoreContributors={async () => {
            await fetchContributors();
          }}
          owners={owners}
          ownersResponse={ownersResponse}
          onShowMoreOwners={async () => {
            await fetchOwners();
          }}
          endorsers={endorsers}
          loading={loading}
        />
      </DesignSystemModal>
    </div>
  );
};

export default KudosDetailsModal;
